import { RemoveRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { Issue } from '../../IssueTrackerContext/types'
import { IssueStatus, Permission } from 'shared'
import { useSoftRemoveIssueMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleRemoveNotification } from 'hooks/notificationHandler'
import { useIssueTrackerContext } from '../../IssueTrackerContext'
import { useClosedDisabledMessage } from '../../../../../../../../../components/CIMSTable/common/hooks/useClosedDisabledMessage'

export function useRemove(): RemoveRowActionOptions<Issue> {
  const { issues } = useIssueTrackerContext()
  const [remove] = useSoftRemoveIssueMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      softRemoveIssue: {
        issue: { formattedNumber },
      },
    }) => simpleRemoveNotification(formattedNumber),
  })
  return {
    permission: Permission.RemoveRestoreIssue,
    disabled: useClosedDisabledMessage('removed', [
      IssueStatus.Closed,
      IssueStatus.Unlocked,
    ]),
    onRemove: async ({ id }) => {
      await remove({ variables: { id } })
      issues.refetch()
    },
  }
}
